module.exports = __webpack_public_path__ + "static/media/logo.eceb1e0b.png";